import React, { useContext, useEffect, useState } from "react"

import Ding from "assets/ding.mp3"

import EventEmitter from "src/EventEmitter"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import CloudroomContext from "../CloudroomContext"

const SessionReassignmentModal = () => {
  const { localUser } = useContext(CloudroomContext)
  const [sessionReassignedTo, setSessionReassignedTo] = useState<string | null>(
    null
  )

  useEffect(() => {
    if (localUser.type !== "Student") return

    const onSessionReassignment = data => {
      new Audio(Ding).play()
      setSessionReassignedTo(data.redirectTo)
      setTimeout(() => {
        window.location.href = data.redirectTo
      }, 5000)
    }
    EventEmitter.subscribe("session_reassignment", onSessionReassignment)

    return () =>
      EventEmitter.unsubscribe("session_reassignment", onSessionReassignment)
  }, [localUser.type])

  if (!sessionReassignedTo) return null

  return (
    <ModalWithProvidedBody
      isOpen
      hideTrigger
      modalClassName="bootstrap-modal"
      modalTitle="Your session is moving"
      hideCloseButton
    >
      <div className="modal-body">
        <p className="lead">
          Your tutor wasn't able to make your session, so we are moving you to
          another session. Please wait a few seconds...
        </p>
      </div>
    </ModalWithProvidedBody>
  )
}

export default SessionReassignmentModal
